import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiGlobe, FiSearch } from 'react-icons/fi';

const WebscrapeCollection = ({ currentProject, onDataImported }) => {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleScrape = async (e) => {
    e.preventDefault();
    if (!url.trim()) return;

    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/data/scrape', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          projectId: currentProject.id,
          url: url.trim()
        }),
      });

      const data = await response.json();
      
      if (response.ok) {
        onDataImported(data.profile, [], []);
        setUrl('');
      } else {
        setError(data.error || 'Scraping failed');
      }
    } catch (err) {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 h-fit">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-2 bg-purple-100 rounded-lg">
          <FiGlobe className="h-6 w-6 text-purple-600" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Website Scrape</h3>
          <p className="text-sm text-gray-600">Extract basic details from any website URL</p>
        </div>
      </div>

      <form onSubmit={handleScrape} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Website URL
          </label>
          <input
            type="url"
            className="input-field"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
          />
        </div>

        <button
          type="submit"
          disabled={loading || !url.trim()}
          className="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Scraping Website...
            </div>
          ) : (
            <div className="flex items-center justify-center space-x-2">
              <FiSearch className="h-4 w-4" />
              <span>Scrape Website</span>
            </div>
          )}
        </button>
      </form>

      {error && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700"
        >
          {error}
        </motion.div>
      )}
    </div>
  );
};

export default WebscrapeCollection;